import React, { useState } from 'react';
import { Dropdown, Button, Space, message, Badge, Tooltip } from 'antd';
import { 
  DownloadOutlined, 
  AndroidOutlined, 
  AppleOutlined,
  UpOutlined, 
  DownOutlined,
  MobileOutlined
} from '@ant-design/icons';
import apple from '../assets/app/apple.png';
import play from '../assets/app/play.png';
import Actadcd_android from '../assets/app/Actadcd_android.apk';
import Actadcd_apple from '../assets/app/actadcd.ipa';
import { MdDownloadForOffline } from "react-icons/md";

function AppDownload({ click }) {
  const [isOpen, setIsOpen] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [downloading, setDownloading] = useState(null);

  const handleDownload = async (platform, file, fileName) => {
    try {
      setDownloading(platform);
      
      // Simulate download preparation
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Create a temporary anchor element to trigger download
      const link = document.createElement('a');
      link.href = file;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Show success message with platform-specific icon
      messageApi.open({
        type: 'success',
        content: `${platform} app download started!`,
        icon: platform === 'Android' ? <AndroidOutlined /> : <AppleOutlined />,
        duration: 3,
      });
      
      setIsOpen(false);
    } catch (error) {
      messageApi.error({
        content: 'Download failed. Please try again.',
        duration: 4,
      });
    } finally {
      setDownloading(null);
    }
  };

  const items = [
    {
      key: 'android',
      label: (
        <Space direction="vertical" size={0} className="py-1">
          <span className="font-medium">Download Android App</span>
          <span className="text-xs text-gray-400">Version 2.1.0 • 61 MB</span>
        </Space>
      ),
      extra: <img src={play} alt="Android" className=" w-24 h-8 object-cover" />,
      onClick: () => handleDownload('Android', Actadcd_android, 'Actadcd_android.apk'),
      disabled: downloading === 'Android',
    },
    {
      key: 'ios',

      label: (
        <Space direction="vertical" size={0} className="py-1">
          <span className="font-medium">Download iOS App</span>
          <span className="text-xs text-gray-400">Version 2.1.0 • 25 MB</span>
        </Space>
      ),
      extra:     <img src={apple} alt="iOS" className=" w-24 h-8 object-cover"/>,
      onClick: () => handleDownload('iOS', Actadcd_apple, 'actadcd.ipa'),
      disabled: downloading === 'iOS',
    },
  ];

  return (
    <>
      {contextHolder}
      <Tooltip title="Download Mobile App" placement="left">
        <Dropdown
          menu={{ 
            items,
            className: 'py-2 min-w-[280px]',
          }}
          placement="bottomRight"
          trigger={['click']}
          open={isOpen}
          onOpenChange={setIsOpen}
          overlayClassName="app-download-dropdown"
        >
          <Badge  size="small" offset={[-5, 5]}>
            <Button 
              type="primary"
              shape="circle"
              icon={isOpen ? <MdDownloadForOffline size={26} /> : <MdDownloadForOffline size={26}  />}
              className="bg-orange-700 hover:bg-orange-800 border-none shadow-md hover:shadow-lg transition-all duration-200 flex items-center justify-center"
              size="large"
              loading={downloading}
            />
          </Badge>
        </Dropdown>
      </Tooltip>

      <style jsx global>{`
        .app-download-dropdown .ant-dropdown-menu {
          border-radius: 12px;
          padding: 8px;
        }
        
        .app-download-dropdown .ant-dropdown-menu-item {
          border-radius: 8px;
          margin: 4px 0;
          padding: 8px 12px;
          transition: all 0.2s;
        }
        
        .app-download-dropdown .ant-dropdown-menu-item:hover {
          background: linear-gradient(to right, #f9f9f9, #f0f9f0);
        }
        
        .app-download-dropdown .ant-dropdown-menu-item:last-child {
          opacity: 0.7;
          cursor: default;
          background: #f5f5f5;
        }
        
        .app-download-dropdown .ant-dropdown-menu-item:last-child:hover {
          background: #f5f5f5;
        }
        
        .app-download-dropdown .ant-dropdown-menu-item-divider {
          margin: 8px 0;
        }
        
        @media (max-width: 640px) {
          .app-download-dropdown .ant-dropdown-menu {
            min-width: 240px;
          }
        }
      `}</style>
    </>
  );
}

export default AppDownload;